import { Slide } from "react-reveal";
const call =
  "https://res.cloudinary.com/malidad/image/upload/v1777961704/phone_ti0ggf.svg";
const email =
  "https://res.cloudinary.com/malidad/image/upload/v1777961703/email_cfuqlz.svg";
const map =
  "https://res.cloudinary.com/malidad/image/upload/v1777961704/map_f7nsgy.svg";

const Contacts = () => {
  return (
    <ul className="home-contact-items-container">
      <li className="home-contact-item">
        <h3>Call Us</h3>
        <p className="font-inter-regular">Call us anytime...</p>
        <div>
          <p>
            <img src={call} alt="Call Icon" />{" "}
            <a href="tel:+256702096666">+256-702-096-666</a>
          </p>
          <p>
            <img src={call} alt="Call Icon" />{" "}
            <a href="tel:+13153470333">+1-315-347-0333</a>
          </p>
          <p>
            <img src={call} alt="Call Icon" />{" "}
            <a href="tel:+256771001999">+256-771-001-999</a>
          </p>
        </div>
      </li>
      <li className="home-contact-item">
        <h3>Email Us</h3>
        <p className="font-inter-regular">Send us an email...</p>
        <div>
          <p>
            <img src={email} alt="Email Icon" />{" "}
            <a href="mailto:inquiry@ntuna.com">inquiry@ntuna.com</a>
          </p>
          <p>
            <img src={email} alt="Email Icon" />{" "}
            <a href="mailto:info@ntuna.com">info@ntuna.com</a>
          </p>
          <p>
            <img src={email} alt="Email Icon" />{" "}
            <a href="mailto:ntuna.info@gmail.com">ntuna.info@gmail.com</a>
          </p>
        </div>
      </li>
      <li className="home-contact-item">
        <h3>Our Offices</h3>
        <p>Schedule a meeting...</p>
        <div>
          <p>
            <img src={map} alt="Map Icon" />{" "}
            <a
              href="https://wa.me/256702096666"
              target="_blank"
              rel="noopener noreferrer"
            >
              Buganda Road, Kampala
            </a>
          </p>
          <p>
            <img src={map} alt="Map Icon" />{" "}
            <a
              href="https://wa.me/13153470333"
              target="_blank"
              rel="noopener noreferrer"
            >
              42 Syracuse Ave, New York
            </a>
          </p>
          <p>
            <img src={map} alt="Map Icon" />{" "}
            <a
              href="https://wa.me/13153470333"
              target="_blank"
              rel="noopener noreferrer"
            >
              500 Jorrison Street, Pretoria
            </a>
          </p>
        </div>
      </li>
      <li className="home-contact-cta-container">
        <Slide top>
          <h3 className="ntuna-text-fill">Ready for business?</h3>
        </Slide>

        <p className="font-inter-regular">Let's start your project</p>
        <a
          href="https://form.jotform.com/ntuna/get-free-quote"
          target="_blank"
          rel="noopener noreferrer"
          className="maincta button boldTitle"
        >
          <span>Request Free Quote</span>
        </a>
      </li>
    </ul>
  );
};

export default Contacts;
